import { Card, Stack, Typography } from "@mui/material";
import { useTranslations } from "hooks/useTranslations";
import React from "react";
import { sharedStyles } from "./cardStyles";
import { IContactPerson, MediaQuery } from "@thekilroygroup/shared-ui";
interface IProps {
  contactPerson: IContactPerson;
  children: any;
}
export const ContactPersonCard = (props: IProps) => {
  const translations = useTranslations().translations;
  const content = translations.confirmationPage.contactPerson;
  const { contactPerson, children } = props;

  return (
    <>
      <MediaQuery min="md">{children}</MediaQuery>
      <Card sx={sharedStyles.card}>
        <MediaQuery max="md">{children}</MediaQuery>
        <Typography sx={sharedStyles.cardHeader} variant="h5">
          {content.title}
        </Typography>

        <Stack sx={sharedStyles.wrapper}>
          <Typography sx={sharedStyles.label}>{content.name}</Typography>
          <Typography sx={sharedStyles.value}>
            {contactPerson.firstName} {contactPerson.middleName}{" "}
            {contactPerson.lastName}
          </Typography>
        </Stack>
        <Stack sx={sharedStyles.wrapper}>
          <Typography sx={sharedStyles.label}>{content.phone}</Typography>
          <Typography sx={sharedStyles.value}>
            +{contactPerson.phoneCountryCode} {contactPerson.phoneNo}
          </Typography>
        </Stack>
        <Stack sx={sharedStyles.wrapper}>
          <Typography sx={sharedStyles.label}>{content.email}</Typography>
          <Typography sx={sharedStyles.value}>{contactPerson.email}</Typography>
        </Stack>
      </Card>
    </>
  );
};
